import { SVGProps } from 'react';

export const QuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 11.874V13H9V10H10C11.103 10 12 9.103 12 8C12 6.896 11.103 6 10 6C8.897 6 8 6.896 8 8H6C6 5.794 7.794 4 10 4C12.206 4 14 5.794 14 8C14 9.86 12.723 11.428 11 11.874ZM10 16.25C9.31 16.25 8.75 15.69 8.75 15C8.75 14.31 9.31 13.75 10 13.75C10.69 13.75 11.25 14.31 11.25 15C11.25 15.69 10.69 16.25 10 16.25ZM10 0C4.486 0 0 4.486 0 10C0 15.515 4.486 20 10 20C15.514 20 20 15.515 20 10C20 4.486 15.514 0 10 0Z"
      fill="currentColor"
    />
  </svg>
);
